module.exports = __webpack_public_path__ + "../resources/images/DragToCalendar-eba7fb945642f8cfedb7fbf4fd70a6d2.gif";